export default __webpack_public_path__ + "static/media/lilb.png.webp";